module.exports = __webpack_public_path__ + "img/real-time01.d9bbc886.jpg";